export default "__VITE_ASSET__ee5e77b8__"